<template>
	<div>
		<p>
			<span v-if="$tera.project.isMeasuredPublicationBias">
				{{
					selectRandom([
						"We assessed publication bias / small studies effect using",
						"Publication bias / small studies effect was assessed using:"
					])
				}}
				{{
					$tera.project.biasMeasurement == "Other"
						? $tera.project.biasMeasurementOther
						: $tera.project.biasMeasurement
						? $tera.project.biasMeasurement
						: "BLANK"
				}}.
			</span>
			<span v-else>
				We did not assess publication bias / small studies effect because
				{{ $tera.project.didNotMeasure ? $tera.project.didNotMeasure : "BLANK" }}.
			</span>
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputPublicationBias",
	mixins: [OutputMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
